import {GARoleTypeId} from '../../../util/uiconstants';
import selectAllEngagements from './selectAllEngagements';

export default (store) =>
	selectAllEngagements(store)?.filter(({roleType}) => [GARoleTypeId.Primary, GARoleTypeId.Region].includes(roleType));
